export const showHideWelcomeMessage = (bool) => {
  return { type: 'SHOW_WELCOME_MESSAGE', payload: bool };
};

export const setMobileView = (screenWidth) => {
  return { type: 'SET_MOBILE_VIEW', payload: screenWidth < 1024 };
};
